import script from "./MediaPlayer.vue?vue&type=script&setup=true&lang=ts"
export * from "./MediaPlayer.vue?vue&type=script&setup=true&lang=ts"

import "./MediaPlayer.vue?vue&type=style&index=0&id=bef64000&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bef64000"]])

export default __exports__